import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AzmoonMaharatRequest_Interface, Empty_AzmoonMaharatRequest_Interface } from 'src/app/Interface/AzmoonMaharatRequest_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { AzmoonMaharatService } from 'src/app/Service/AzmoonMaharat/AzmoonMaharat.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-AzmoonMaharatRequestCalender',
  templateUrl: './AzmoonMaharatRequestCalender.component.html',
  styleUrls: ['./AzmoonMaharatRequestCalender.component.scss']
})
export class AzmoonMaharatRequestCalenderComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false
  BaseUrl = environment.BaseUrl+"File/AzmoonMaharat/"
  modalRef_Delete: any;
  modalRef_SignIn: any;

  constructor(
    private AzmoonMaharat_Service:AzmoonMaharatService,
    private Alertify_Service:AlertifyService,
    private modalService: BsModalService
  ) { }


  DataList_AzmoonMaharat:Array<AzmoonMaharatRequest_Interface>=[]
  Data_Seleted_Delete:AzmoonMaharatRequest_Interface=Empty_AzmoonMaharatRequest_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.ReadData_AzmoonMaharat()    
  }

  ReadData_AzmoonMaharat(){
    this.Procssing=true
    this.AzmoonMaharat_Service.GetRequestCalender(this.Token).subscribe(
      data=>{
        this.DataList_AzmoonMaharat=data
        this.Procssing=false
      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  openModal(template: TemplateRef<any>, Record:AzmoonMaharatRequest_Interface) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  openModalSignIn(template: TemplateRef<any>, Record:AzmoonMaharatRequest_Interface) {
    this.Data_Seleted_Delete = Record
    this.modalRef_SignIn = this.modalService.show(template);
  }

  
  SignIn(item:AzmoonMaharatRequest_Interface){
    item.canSignInCount=item.canSignInCount+1
    this.modalRef_SignIn.hide()
    this.Procssing=true
    this.AzmoonMaharat_Service.SubmitRequest(this.Token,item.id).subscribe(
      data=>{
        this.Procssing=false
        if(data['id']==1)
        {
          this.Alertify_Service.SuccessMessage("Registration completed successfully")
        }
        else{
          this.Alertify_Service.ErrorMessage("The registration period has ended")
        }
      }
    )
  }


}
